import { OPEN_ID, PROFILE, OFFLINE_ACCESS, API } from './msal/scopes';

export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const AUTHORITY = process.env.REACT_APP_AUTHORITY;
export const KNOWN_AUTHORITIES = [process.env.REACT_APP_KNOWN_AUTHORITY];
export const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URI;
export const LOGIN_SCOPES = [OPEN_ID, PROFILE, OFFLINE_ACCESS];
export const ACCESS_TOKEN_SCOPES = [API];
